/**
 * Stripe Subscription Types
 * Adapted for Floaty's React (Vite) + Supabase architecture
 */

export type SubscriptionStatus = 'trial' | 'active' | 'canceled' | 'past_due' | 'expired'

export interface SubscriptionRecord {
  id: string
  user_id: string
  stripe_customer_id: string | null
  stripe_subscription_id: string | null
  price_id: string | null
  status: SubscriptionStatus
  trial_ends_at: string
  recordings_limit: number
  guests_limit: number
  recordings_used: number
  guests_used: number
  series_limit: number
  series_used: number
  episodes_per_series_limit: number
  current_period_end: string | null
  created_at: string
  updated_at: string
}

export interface PricingTier {
  id: string // Stripe price_id
  productId: string
  name: string
  description: string | null
  price: number // in cents
  interval: 'month' | 'year'
  metadata: {
    recordings?: string
    guests?: string
    series?: string
    episodes_per_series?: string
  }
}

export const FREE_TRIAL: PricingTier = {
  id: 'free_trial',
  productId: 'free_trial',
  name: 'Free Trial',
  description: '1 month free to get started',
  price: 0,
  interval: 'month',
  metadata: {
    recordings: '4',
    guests: '8',
    series: '1',
    episodes_per_series: '4',
  },
}

/**
 * Derived subscription state for UI consumption
 */
export interface SubscriptionState {
  subscription: SubscriptionRecord | null
  isLoading: boolean

  // Status checks
  isTrialActive: boolean
  isTrialExpired: boolean
  isPaid: boolean
  isReadOnly: boolean // Can view but not create

  // Legacy recording limits (kept for backward compatibility)
  canCreateRecording: boolean
  recordingsRemaining: number

  // Guest limits
  canAddGuest: boolean
  guestsRemaining: number

  // Series limits
  canCreateSeries: boolean
  seriesRemaining: number
  episodesPerSeriesLimit: number

  // Trial info
  trialDaysRemaining: number | null
}

/**
 * Checkout session response from create-checkout edge function
 */
export interface CheckoutSession {
  url: string
}

/**
 * Portal session response from create-portal edge function
 */
export interface PortalSession {
  url: string
}
